// GitActions.js
// Advanced Git actions panel for IDE
import React, { useState } from 'react';

const GitActions = () => {
  const [committing, setCommitting] = useState(false);
  const [commitMsg, setCommitMsg] = useState('');
  const [log, setLog] = useState([]);

  // Placeholder: In real app, connect to backend
  const handleCommit = () => {
    if (!commitMsg.trim()) return;
    setCommitting(true);
    setTimeout(() => {
      setLog(l => [
        { msg: commitMsg, date: new Date().toLocaleString() },
        ...l
      ]);
      setCommitMsg('');
      setCommitting(false);
    }, 900);
  };

  return (
    <div style={{ background: '#181818', color: '#fff', borderRadius: 10, boxShadow: '0 2px 12px #0003', padding: 18, minWidth: 320, maxWidth: 420 }}>
      <h3 style={{ marginTop: 0, fontWeight: 600, fontSize: 18 }}>Git Actions</h3>
      <div style={{ marginBottom: 12 }}>
        <input
          value={commitMsg}
          onChange={e => setCommitMsg(e.target.value)}
          placeholder="Commit message"
          style={{ width: '100%', padding: 8, borderRadius: 6, border: 'none', fontSize: 15 }}
          disabled={committing}
        />
        <button
          onClick={handleCommit}
          disabled={committing || !commitMsg.trim()}
          style={{ marginTop: 8, background: '#6366f1', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 18px', fontWeight: 500, cursor: 'pointer', float: 'right' }}
        >
          {committing ? 'Committing...' : 'Commit'}
        </button>
      </div>
      <div style={{ maxHeight: 120, overflowY: 'auto', fontSize: 14 }}>
        <strong>Recent Commits:</strong>
        <ul style={{ paddingLeft: 18 }}>
          {log.map((c, i) => (
            <li key={i} style={{ marginBottom: 4 }}>
              <span style={{ color: '#6ee7b7' }}>{c.date}:</span> {c.msg}
            </li>
          ))}
          {log.length === 0 && <li style={{ color: '#888' }}>No commits yet.</li>}
        </ul>
      </div>
    </div>
  );
};

export default GitActions;
